interface GeocodeResult {
  zipCode: string | null;
  latitude: string | null;
  longitude: string | null;
  error?: string;
}

/**
 * Fetches geocode data from OpenStreetMap Nominatim API
 * @param address - Full address string to geocode
 * @returns Promise<GeocodeResult>
 */
const fetchGeocode = async (address: string): Promise<GeocodeResult> => {
    console.log(address,'address')
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`,
      {
        headers: {
          'User-Agent': 'Gwarm/1.0 (zeya@gwarm.net)' // Required by Nominatim
        }
      }
    );

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    
    if (!data || data.length === 0) {
      return { 
        zipCode: null, 
        latitude: null, 
        longitude: null,
        error: "No results found" 
      };
    }

    const firstResult = data[0];
    return {
      zipCode: firstResult.address?.postcode || null,
      latitude: firstResult.lat,
      longitude: firstResult.lon
    };
    
  } catch (error) {
    console.error("Geocoding failed:", error);
    return {
      zipCode: null,
      latitude: null,
      longitude: null,
      error: error instanceof Error ? error.message : "Geocoding failed"
    };
  }
};

// Usage Example
export const populateSenderData = async (sender: any) => {
  const addressVal = sender?.location || sender?.address || "";
  const fullAddress = `${addressVal}, ${sender?.districtName || ""}, ${sender?.cityName || ""}, ${sender?.countryName || ""}`;
  
  const { zipCode, latitude, longitude, error } = await fetchGeocode(fullAddress);

  const isSaudi =
    sender?.countryName === "Saudi Arabia" ||
    sender?.country === "Saudi Arabia" ||
    sender?.country === "1";

  if (error) {
    console.warn("Geocoding failed. Using fallback only if not Saudi Arabia.");
    return {
      ...sender,
      zipCode: sender?.zipCode || (isSaudi ? "" : "302020"), // No Jaipur fallback for Saudi
      latitude: sender?.latitude || latitude || (isSaudi ? "" : "26.8636"),
      longitude: sender?.longitude || longitude || (isSaudi ? "" : "75.7877")
    };
  }

  return {
    ...sender,
    zipCode: zipCode || sender?.zipCode,
    latitude: latitude || sender?.latitude,
    longitude: longitude || sender?.longitude
  };
};